import Button from "./Button";

interface NumericKeypadProps {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
}

export default function NumericKeypad({ value, onChange, maxLength = 4 }: NumericKeypadProps) {
  const append = (digit: string) => {
    if (value.length < maxLength) {
      onChange(value + digit);
    }
  };

  const backspace = () => {
    onChange(value.slice(0, -1));
  };

  const clear = () => {
    onChange("");
  };

  const digits = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

  return (
    <div className="grid grid-cols-3 gap-2">
      {digits.map((d) => (
        <Button
          key={d}
          type="button"
          className="h-14 text-xl"
          onClick={() => append(d)}
          disabled={value.length >= maxLength}
        >
          {d}
        </Button>
      ))}
      <Button type="button" variant="secondary" className="h-14 text-base" onClick={clear}>
        C
      </Button>
      <Button type="button" className="h-14 text-xl" onClick={() => append("0")} disabled={value.length >= maxLength}>
        0
      </Button>
      <Button type="button" variant="secondary" className="h-14 text-base" onClick={backspace}>
        ⌫
      </Button>
    </div>
  );
}
